var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useState } from 'react';
import AnimatedWrapper from '../AnimatedWrapper/AnimatedWrapper';
import * as Styled from './ButtonTag.styled';
/**
 * `ButtonTag` is a compact element that represent an input, attribute, or action.
 * Use `AnimatedButtonTag` if you would like ButtonTag to fade in/out on mount/unmount.
 */
export var ButtonTag = function (_a) {
    var label = _a.label, onDelete = _a.onDelete, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, inputProps = __rest(_a, ["label", "onDelete", "variant"]);
    return (React.createElement(Styled.ButtonTag, __assign({ as: onDelete && 'button', variant: variant, onClick: onDelete }, inputProps),
        React.createElement("span", null, label),
        onDelete && React.createElement(Styled.Icon, { name: "close" })));
};
/**
 * `AnimatedButtonTag` is a compact elements that represent an input, attribute, or action.
 * Use `ButtonTag` if you would not like ButtonTag to fade in/out on mount/unmount.
 */
export var AnimatedButtonTag = function (_a) {
    var label = _a.label, onDelete = _a.onDelete, _b = _a.variant, variant = _b === void 0 ? 'default' : _b, position = _a.position, allFilters = _a.allFilters, _c = _a.timeout, timeout = _c === void 0 ? 200 : _c, inputProps = __rest(_a, ["label", "onDelete", "variant", "position", "allFilters", "timeout"]);
    var _d = useState(true), isMounted = _d[0], setIsMounted = _d[1];
    var handleRemove = function () {
        setIsMounted(false);
    };
    // We want to remove the element immediately if it's the only one
    var isLastAndOnlyAndUnmounting = (allFilters === null || allFilters === void 0 ? void 0 : allFilters.length) === 1 && position === 0 && !isMounted;
    var effectiveTimeout = isLastAndOnlyAndUnmounting ? 0 : timeout;
    return (React.createElement(AnimatedWrapper, { visible: isMounted, onDelete: onDelete, timeout: effectiveTimeout, exitClass: isLastAndOnlyAndUnmounting ? 'fade-out' : 'shrink-fade-out' },
        React.createElement(ButtonTag, __assign({ label: label, onDelete: handleRemove, variant: variant }, inputProps))));
};
export default ButtonTag;
